import { Box, Heading, Tabs, Text } from '@chakra-ui/react';
import Users from './Users.jsx';
import ArticleNameMaster from './ArticleNameMaster.jsx';

const Master = () => {
  return (
    <Box>
      <Heading size="lg" mb={6}>Master Configuration</Heading>
      
      <Tabs.Root defaultValue="users">
        <Tabs.List>
          <Tabs.Trigger value="users">
            Users & Permissions
          </Tabs.Trigger>
          <Tabs.Trigger value="articleNames">
            Article Names
          </Tabs.Trigger>
          {/* Future master configs can go here */}
          <Tabs.Trigger value="settings" disabled>
            General Settings (Coming Soon)
          </Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="users" pt={4}>
          <Users />
        </Tabs.Content>

        <Tabs.Content value="articleNames" pt={4}>
          <ArticleNameMaster />
        </Tabs.Content>
        
        <Tabs.Content value="settings" pt={4}>
          <Text color="gray.500">Global settings will appear here.</Text>
        </Tabs.Content>
      </Tabs.Root>
    </Box>
  );
};

export default Master;
